<template>
<!-- 主流软件和插件 -->
  <div class="container software">
    <div class="software-header">
      <h2 class="title">支持全部主流软件和插件</h2>
      <p class="desc">可自定义用户环境</p>
    </div>
    <el-row class="count-list">
      <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3" v-for="(item, index) in softwareList" :key="index">
        <div class="software-item flex-align-center flex-center">
          <div>
            <div class="software-img">
              <el-image :src="item.image" alt="" :lazy="true">
                <div slot="placeholder" class="image-slot">
                  <img :src="item.loadImg" alt="">
                </div>
              </el-image>
            </div>
            <p class="software-title">{{ item.title }}</p>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<style lang="scss" scoped>
  .el-col-lg-7 {
    width: 14%;
  }
</style>
<script>
export default {
  data() {
    return {
      softwareList: [
        {
          image: require('../../assets/image/software/classise.png'),
          loadImg: require('../../assets/image/loadimg/classise.png'),
          title: 'Clarisse'
        },
        {
          image: require('../../assets/image/software/maya.png'),
          loadImg: require('../../assets/image/loadimg/maya.png'),
          title: 'Maya'
        },
        {
          image: require('../../assets/image/software/3ds-max.png'),
          loadImg: require('../../assets/image/loadimg/3ds-max.png'),
          title: '3ds Max'
        },
        {
          image: require('../../assets/image/software/blender.png'),
          loadImg: require('../../assets/image/loadimg/blender.png'),
          title: 'Blender'
        },
        {
          image: require('../../assets/image/software/UnrealEngine.png'),
          loadImg: require('../../assets/image/loadimg/UnrealEngine.png'),
          title: 'Unreal Engine'
        },
        {
          image: require('../../assets/image/software/Cinema4d.png'),
          loadImg: require('../../assets/image/loadimg/Cinema4d.png'),
          title: 'Cinema 4d'
        },
        {
          image: require('../../assets/image/software/SketchUp.png'),
          loadImg: require('../../assets/image/loadimg/SketchUp.png'),
          title: 'SketchUp'
        },
        {
          image: require('../../assets/image/software/Katana.png'),
          loadImg: require('../../assets/image/loadimg/Katana.png'),
          title: 'Katana'
        },
        {
          image: require('../../assets/image/software/houdini.png'),
          loadImg: require('../../assets/image/loadimg/houdini.png'),
          title: 'Houdini'
        },
        {
          image: require('../../assets/image/software/Corona.png'),
          loadImg: require('../../assets/image/loadimg/Corona.png'),
          title: 'Corona'
        },
        {
          image: require('../../assets/image/software/Arnold.png'),
          loadImg: require('../../assets/image/loadimg/Arnold.png'),
          title: 'Arnold'
        },
        {
          image: require('../../assets/image/software/V-Ray.png'),
          loadImg: require('../../assets/image/loadimg/V-Ray.png'),
          title: 'V-Ray'
        },
        {
          image: require('../../assets/image/software/Redshift.png'),
          loadImg: require('../../assets/image/loadimg/Redshift.png'),
          title: 'Redshift'
        },
        {
          image: require('../../assets/image/software/RenderMan.png'),
          loadImg: require('../../assets/image/loadimg/RenderMan.png'),
          title: 'RenderMan'
        },
        {
          image: require('../../assets/image/software/Octane.png'),
          loadImg: require('../../assets/image/loadimg/Octane.png'),
          title: 'Octane'
        },
        {
          image: require('../../assets/image/software/Anima.png'),
          loadImg: require('../../assets/image/loadimg/Anima.png'),
          title: 'Anima'
        },
        // {
        //   image: require('../../assets/image/software/Nuke.png'),
        //   loadImg: require('../../assets/image/loadimg/Nuke.png'),
        //   title: 'Nuke'
        // },
        // {
        //   image: require('../../assets/image/software/Terragen.png'),
        //   loadImg: require('../../assets/image/loadimg/Terragen.png'),
        //   title: 'TerraGen'
        // },
      ]
    }
  },
}
</script>
